import useIconColor from '../../hooks/useIconColor';

const Email = () => {
  const { background } = useIconColor();

  return (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M20.7094 15.5529V8.0907L16.9219 11.9852L20.7094 15.5517M14.3171 14.6618C13.6995 15.3003 12.8591 15.6583 11.9833 15.6561C11.102 15.6561 10.272 15.3028 9.64837 14.6618L7.61689 12.5723L3.2572 16.6801V17.3682C3.2572 18.2685 3.96895 19.0001 4.84357 19.0001H19.123C19.9976 19.0001 20.7094 18.2685 20.7094 17.3694V16.6584L16.3597 12.562L14.3182 14.6606'
        fill={background}
      />
      <path
        d='M19.1554 5H4.87591C4.00241 5 3.29179 5.73168 3.29179 6.63075V6.97137L10.243 14.1193C10.7171 14.6055 11.3474 14.8739 12.0167 14.8739C12.6872 14.8739 13.3175 14.6055 13.7905 14.1193L20.7428 6.97137V6.63075C20.7428 5.73168 20.0289 5 19.1554 5ZM3.2572 8.09059V15.5734L7.05464 11.9954L3.2572 8.09059Z'
        fill={background}
      />
    </svg>
  );
};

export default Email;
